<template>
  <div class="product-collect"
    v-loading="loading"
    element-loading-text="默认目录创建中...">
    <catalog-tree
      ref="catalogTree"
      categoryType="ResourceFavoriteDir"
      @dirChanged="dirChanged"
      viewHeight="calc(100vh - 53px)"
      affixTop="32px"
      orderBy="CreateDate asc"
      title="收藏目录"
      :defaultNode="[{DirName: '我的开放资源', DirID: 0, TreeID: 'list_0'}]"
    ></catalog-tree>
    <data-list ref="dataListRef" />
  </div>
</template>

<script>
import {TreeService} from '@/service'
import {Category} from '@/libs'
import CatalogTree from '@/components/tree-list/catalog-tree.vue';
import DataList from './data-list.vue';
import {AutoCreateResDir} from './defaultData';

export default {
  components: { CatalogTree, DataList },
  data() {
    return {
      loading: false,
    }
  },
  mounted() {
    this.autoCreat();
  },
  methods: {
    async autoCreat() {
      const dirList = await TreeService.get(0, Category.ResourceFavoriteDir);
      if (dirList.length > 0) {
        return;
      }
      this.loading = true;
      await AutoCreateResDir();
      this.loading = false;
      location.reload();
    },
    dirChanged(data, parents) {
      this.$refs.dataListRef.dirChanged(data.DirID || 0, parents);
    },
    // 重新计算树DataCount
    dragDataCallback(toId, fromId) {
      this.$refs.catalogTree.dragDataCallback({
        toId,
        fromId,
      })
    }
  }
}
</script>

<style lang="less" scoped>
.product-collect{
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
}
</style>
